import { renderToString } from 'preact-render-to-string';
import { MwlIcons } from "../components/MwlIcons";
import i18n from '@i18n';

export const initMetadataToggle = (lightbox, metadata_toggle) => {
  let isMetadataHidden = metadata_toggle.start_hidden || false;

  lightbox.on('uiRegister', () => {
    const infoIcon = <MwlIcons icon={'expand_meta'} />;
    const hideIcon = <MwlIcons icon={'minimize_meta'} />;

    const updateButton = (el) => {
      el.innerHTML = isMetadataHidden ? renderToString(infoIcon) : renderToString(hideIcon);
      el.dataset.tooltip = isMetadataHidden ? i18n.TOOLBAR.SHOW_INFO : i18n.TOOLBAR.HIDE_INFO;
    };

    const updateMetadataVisibility = () => {
      lightbox.pswp.element.classList.toggle('mwl--metadata-hidden', isMetadataHidden);
      // Trigger resize so PhotoSwipe recalculates image position
      lightbox.pswp.updateSize(true);
    };

    lightbox.pswp.ui.registerElement({
      name: 'metadata-toggle-button',
      ariaLabel: isMetadataHidden ? i18n.TOOLBAR.SHOW_INFO : i18n.TOOLBAR.HIDE_INFO,
      order: 8,
      isButton: true,
      html: renderToString(isMetadataHidden ? infoIcon : hideIcon),
      onInit: (el) => {
        el.dataset.tooltip = isMetadataHidden ? i18n.TOOLBAR.SHOW_INFO : i18n.TOOLBAR.HIDE_INFO;
      },
      onClick: (event, el) => {
        isMetadataHidden = !isMetadataHidden;
        updateButton(el);
        updateMetadataVisibility();
      },
    });
  });

  // Apply initial state and maintain on slide changes
  lightbox.on('firstUpdate', () => {
    if (isMetadataHidden) {
      lightbox.pswp.element.classList.add('mwl--metadata-hidden');
      lightbox.pswp.updateSize(true);
    }
  });
};
